import { inject, Provider } from '@angular/core';

import { Store } from '@ngrx/store';
import { SUI_DATE_FORMAT } from '@semeris/ui';
import { isValid } from 'date-fns';
import { UserProfileSelectors } from 'projects/semeris/src/store/user-profile/user-profile.selectors';

import { DateFormat } from '../../models/common/dateformat.enum';
import { DateHelper } from '../../utils/date-helper';

/**
 * Makes every `sui-datepicker` label render in the user's **Date format**
 * (`/settings/profile`), falling back to ISO while the profile is loading.
 *
 * Add once to the root providers in `main.ts`:
 *
 * ```ts
 * providers: [provideSuiDateFormat()]
 * ```
 */
export function provideSuiDateFormat(): Provider {
  return {
    provide: SUI_DATE_FORMAT,
    useFactory: () => {
      const dateFormat = inject(Store).selectSignal(UserProfileSelectors.dateFormat);
      // Read per call — this is what makes a mid-session format change re-render.
      return (date: Date) => (isValid(date) ? DateHelper.format(date, dateFormat() ?? DateFormat.ISO) : '');
    },
  };
}
